import { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';

// "Copiar imóvel": cria um imóvel NOVO a partir de outro (mesmos dados, características e — se marcado — fotos).
// A cópia nasce INATIVA e SEM divulgação, com código novo do mesmo tipo e no nome de quem copiou. Leads, histórico e
// link sincronizado não vão junto. As fotos ficam ligadas às mesmas imagens (não ocupam espaço em dobro); apagar uma
// foto de um imóvel não afeta o outro. Ver painel-node `controllers/imovel.js` (copiar).
export default function ModalCopiarImovel({ show, aoFechar, publicId, codigo, totalFotos, aoCopiado }) {
  const toast = useToast();
  const [copiarFotos, setCopiarFotos] = useState(true);
  const [copiando, setCopiando] = useState(false);

  useEffect(() => {
    if (show) setCopiarFotos(true);
  }, [show]);

  async function confirmar() {
    setCopiando(true);
    try {
      const r = await api.post(`/imoveis/${publicId}/copiar`, { copiarFotos });
      toast.sucesso(`Cópia criada: ${r.resumo?.codigoNovo || 'novo imóvel'}.`);
      aoCopiado(r.data);
    } catch (err) {
      toast.erro(err.message || 'Não foi possível copiar o imóvel');
    } finally {
      setCopiando(false);
    }
  }

  return (
    <Modal show={show} onHide={copiando ? undefined : aoFechar} centered contentClassName="modal-empilhado" backdropClassName="modal-empilhado-fundo">
      <Modal.Header closeButton={!copiando}>
        <Modal.Title>Copiar imóvel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Vai ser criado um <strong>imóvel novo</strong> igual ao <strong>{codigo || 'atual'}</strong>, com um <strong>código novo</strong> do
          mesmo tipo e no seu nome.
        </p>
        <Alert variant="warning" className="small">
          <ul className="mb-0">
            <li>
              A cópia nasce <strong>inativa e sem divulgação</strong> (site da empresa, site da rede, TV, portais, destaque e oportunidade
              desmarcados). Revise e ative quando estiver pronta — assim nunca aparece um anúncio repetido sem querer.
            </li>
            <li>São copiados: dados, endereço, valores, descrições, proprietário e características.</li>
            <li>Não são copiados: leads, histórico e o link já sincronizado.</li>
          </ul>
        </Alert>
        <Form.Check
          id="copiar-fotos"
          type="checkbox"
          label={`Copiar também as fotos${typeof totalFotos === 'number' ? ` (${totalFotos})` : ''}`}
          checked={copiarFotos}
          onChange={(e) => setCopiarFotos(e.target.checked)}
          disabled={copiando}
        />
        <Form.Text muted>
          As fotos ficam ligadas às mesmas imagens: não ocupam espaço em dobro, e apagar uma foto de um dos imóveis não afeta o outro.
        </Form.Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={aoFechar} disabled={copiando}>Cancelar</Button>
        <Button variant="primary" onClick={confirmar} disabled={copiando}>
          {copiando ? 'Copiando…' : 'Criar cópia'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
